import { useSelector } from 'react-redux'

import InitialLoadWrapper from '@/components/util/InitialLoadWrapper'
import { fetchCustomer, getError, getIsDataLoaded, getIsPending } from '@/ducks/customerReducer'
import { getCustomerId } from '@/ducks/shopOrderReducer'

const withQuoteCustomerLoaded =
  // @ts-ignore


    (Component, forceLoadOnMount = true) =>
    // @ts-ignore
    props => {
      const customerId = useSelector(getCustomerId)

      return (
        <InitialLoadWrapper
          loadAction={fetchCustomer}
          loadingSelector={getIsPending}
          // @ts-ignore
          loadedSelector={state => getIsDataLoaded(state, customerId)}
          errorSelector={getError}
          forceLoadOnMount={forceLoadOnMount}
          args={customerId}
        >
          <Component {...props} />
        </InitialLoadWrapper>
      )
    }

export default withQuoteCustomerLoaded
